module.exports = __webpack_public_path__ + "static/media/phoenix-framework.34c8df3f.svg";